import { createBrandSchema } from './create-form.js';
export const brandEditFormSchema = createBrandSchema;
export function emptyBrandEditFormValues() {
    return { name: '' };
}
//# sourceMappingURL=update-form.js.map